/**
 * SoundIcon - Pixel art speaker icon
 * SVG drawn on a 16x16 pixel grid
 */

interface SoundIconProps {
  enabled: boolean;
  size?: number;
}

export function SoundIcon({ enabled, size = 24 }: SoundIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ imageRendering: 'pixelated' }}
    >
      {/* Speaker body */}
      <rect x="1" y="5" width="3" height="6" fill="currentColor" />
      <rect x="4" y="4" width="1" height="8" fill="currentColor" />
      <rect x="5" y="3" width="1" height="10" fill="currentColor" />
      <rect x="6" y="2" width="1" height="12" fill="currentColor" />
      <rect x="7" y="1" width="1" height="14" fill="currentColor" />

      {enabled ? (
        /* Sound waves when enabled */
        <>
          {/* Wave 1 (small) */}
          <rect x="10" y="6" width="1" height="1" fill="currentColor" />
          <rect x="10" y="9" width="1" height="1" fill="currentColor" />

          {/* Wave 2 (medium) */}
          <rect x="12" y="4" width="1" height="1" fill="currentColor" />
          <rect x="12" y="7" width="1" height="2" fill="currentColor" />
          <rect x="12" y="11" width="1" height="1" fill="currentColor" />

          {/* Wave 3 (large) */}
          <rect x="14" y="2" width="1" height="2" fill="currentColor" />
          <rect x="14" y="7" width="1" height="2" fill="currentColor" />
          <rect x="14" y="12" width="1" height="2" fill="currentColor" />
        </>
      ) : (
        /* X mark when muted */
        <>
          <rect x="10" y="4" width="1" height="1" fill="var(--color-red, #E52521)" />
          <rect x="11" y="5" width="1" height="1" fill="var(--color-red, #E52521)" />
          <rect x="12" y="6" width="1" height="1" fill="var(--color-red, #E52521)" />
          <rect x="13" y="7" width="1" height="2" fill="var(--color-red, #E52521)" />
          <rect x="12" y="9" width="1" height="1" fill="var(--color-red, #E52521)" />
          <rect x="11" y="10" width="1" height="1" fill="var(--color-red, #E52521)" />
          <rect x="10" y="11" width="1" height="1" fill="var(--color-red, #E52521)" />

          <rect x="14" y="4" width="1" height="1" fill="var(--color-red, #E52521)" />
          <rect x="13" y="5" width="1" height="1" fill="var(--color-red, #E52521)" />
          <rect x="13" y="10" width="1" height="1" fill="var(--color-red, #E52521)" />
          <rect x="14" y="11" width="1" height="1" fill="var(--color-red, #E52521)" />
        </>
      )}
    </svg>
  );
}
